import React, { useEffect, useState } from 'react'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../../../helpers/form/FormData'
import AgreeSelectMain from '../../../../../../form/fields/AgreeSelectMain'
import { checkValid, setValueForm, updateValidate } from '../../../../../../../helpers/form/FormHelper'
import ErrorMessage from '../../../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../../../UI/form/MyButton'
import { responseError } from '../../../../../../../helpers/response/ResponseHelper'
import { useDispatch } from 'react-redux'
import DisagreeTextMain from '../../../../../../form/fields/DisagreeTextMain'
import { agreeSupplyOrderItemsDirectorAPI } from '../../../../../../../api/supply/supplyOrderAPI'
import { editSupplyOrderItems } from '../../../../../../../store/supplyOrderSlice'

const AgreeDirectorForm = ({ supplyOrderId, checked, setOpen, setChecked }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState({}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()

        setError('')
        setLoading(true)

        agreeSupplyOrderItemsDirectorAPI({
            id: supplyOrderId,
            isAgreeDirector: data.isAgreeDirector,
            disagreeDirectorText: data.disagreeDirectorText,
            checked: checked,
        }).then(data => {
            if (data) {
                dispatch(editSupplyOrderItems(data.items))
                // dispatch(editSupplyBillsItemsAllItem(data))
            }
            if (setChecked) {
                setChecked({})
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Погодження обраних позицій в рахунку директором
            </p>
        </div>
        {
			formDataProductIsField('isAgreeDirector', 'supplyOrderItemAgree') ?
				<AgreeSelectMain
					required={formDataProductRequiredField('isAgreeDirector', 'supplyOrderItemAgree')}
					setValidate={e => updateValidate(setValid, 'isAgreeDirector', e)}
					setValueForm={e => setValueForm(setData, 'isAgreeDirector', e)}
					forciblyValue={
                        data && data.isAgreeDirector === true ? true :
                        data && data.isAgreeDirector === false ? false : ''
                    }
				/>
			: ''
        }
        {
			formDataProductIsField('disagreeText', 'supplyOrderItemAgree') ?
				<DisagreeTextMain
					required={
                        data && (data.isAgreeDirector === false || data.isAgreeDirector === 'no') ? true  :
                        formDataProductRequiredField('disagreeText', 'supplyOrderItemAgree')
                    }
					setValidate={e => updateValidate(setValid, 'disagreeDirectorText', e)}
					setValueForm={e => setValueForm(setData, 'disagreeDirectorText', e)}
					forciblyValue={data ? data.disagreeDirectorText : ''}
                    className={data && (data.isAgreeDirector === false || data.isAgreeDirector === 'no') ? '' : 'hide'}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default AgreeDirectorForm